import styled from "@emotion/styled";

export const MetabotHeaderRoot = styled.header`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
`;
